import type { LightdashUser } from './user';

export type Tag = {
    tagUuid: string;
    projectUuid: string;
    name: string;
    color: string;
    createdAt: Date;
    yamlReference: string | null;
    createdBy: Pick<
        LightdashUser,
        'userUuid' | 'firstName' | 'lastName'
    > | null;
};

export type ApiGetTagsResponse = {
    status: 'ok';
    results: Tag[];
};

export type ApiCreateTagResponse = {
    status: 'ok';
    results: { tagUuid: string };
};

export enum CommonReservedTags {
    HIDDEN = 'srt_hidden',
    INTERNAL = 'srt_internal',
    JOURNEY_TRIGGER_AUDIENCE = 'srt_journey_trigger_audience',
    OTHER_JOURNEYS_TRIGGER = 'srt_other_journeys_trigger',
    CAMPAIGN_CONVERSION_EVENT = 'srt_campaign_conversion_event',
    JOURNEY_CONVERSION_EVENT = 'srt_journey_conversion_audience',
}
export type ApiReplaceYamlTagsResponse = {
    status: 'ok';
    results: undefined;
};
